import React from "react";
import nodata from "../assets/images/no-data.webp";
const Nodata = () => {
  return (
    <div  className="no-result"><div  className="pic">
        <img  alt="no-data" src={nodata} loading="lazy"/></div>
        <div  className="text">No Data</div>
        </div>
  );
};

export default Nodata;
